<template>
	<el-table
		:data="orderedVitals"
		:show-header="false"
		max-height="300px">
		<el-table-column label="Date" width="130">
			<template slot-scope="scope">
				<strong class="date">{{ formatDate(scope.row.time) }}</strong> &middot; {{ formatTime(scope.row.time) }}
			</template>
		</el-table-column>

		<!-- Value -->
		<el-table-column label="Value" width="180">
			<template slot-scope="scope">
				<div v-html="formatValue(scope.row.value, scope.row.unit)"></div>
			</template>
		</el-table-column>

		<!-- Details -->
		<el-table-column label="Detail">
			<template slot-scope="scope">
				&nbsp;
			</template>
		</el-table-column>
	</el-table>
</template>
<script>
import VitalAnalysis from './mixin'

export default {
	name: 'vital-card-analysis-table',
	mixins: [ VitalAnalysis ],

	computed: {
		orderedVitals() {
			return this.event.slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
